export const loraTool = {
  HUAFENG: {
    cn: '画风强化',
    code: '100080',
  },
  JUESHE: {
    cn: '角色强化',
    code: '100216',
  },
  RENWU: {
    cn: '人物强化',
    code: '100081',
  },
  ZHUTI: {
    cn: '主体强化',
    code: '100082',
    tagCode: ['100082', '100084'],
  },
  HUAMIAN: {
    cn: '画面控制',
    code: '100085',
  },
  Other: {
    cn: '其他功能',
    code: '100087',
  },
};

export const loraBestAllStructrues = [
  {
    tip: '基础模型',
    codes: '102000',
    config: [
      {
        type: loraTool.HUAFENG.code,
        num: 8,
      },
      {
        type: loraTool.RENWU.code,
        num: 8,
      },
      {
        type: loraTool.ZHUTI.code,
        num: 8,
      },
      {
        type: loraTool.JUESHE.code,
        num: 8,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 4,
      },
    ],
  },
  {
    tip: '写实-人像',
    codes: '100028',
    level2Code: '100048',
    config: [
      {
        type: loraTool.RENWU.code,
        num: 8,
      },
      {
        type: loraTool.ZHUTI.code,
        num: 4,
      },
      {
        type: loraTool.HUAFENG.code,
        num: 8,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 4,
      },
      {
        type: loraTool.JUESHE.code,
        num: 0,
      },
    ],
  },
  {
    tip: '写实-非人像',
    codes: '100028', // 不包含['100048']
    config: [
      {
        type: loraTool.ZHUTI.code,
        num: 4,
      },
      {
        type: loraTool.RENWU.code,
        num: 8,
      },
      {
        type: loraTool.HUAFENG.code,
        num: 8,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 4,
      },
      {
        type: loraTool.JUESHE.code,
        num: 0,
      },
    ],
  },
  {
    tip: '插画',
    codes: '100030',
    config: [
      {
        type: loraTool.HUAFENG.code,
        num: 16,
      },
      {
        type: loraTool.ZHUTI.code,
        num: 4,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 0,
      },
      {
        type: loraTool.JUESHE.code,
        num: 0,
      },
      {
        type: loraTool.RENWU.code,
        num: 0,
      },
    ],
  },
  {
    tip: '动漫',
    codes: '100027',
    config: [
      {
        type: loraTool.HUAFENG.code,
        num: 12,
      },
      {
        type: loraTool.JUESHE.code,
        num: 8,
      },
      {
        type: loraTool.ZHUTI.code,
        num: 0,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 0,
      },
      {
        type: loraTool.RENWU.code,
        num: 0,
      },
    ],
  },
  {
    tip: 'CG幻想',
    codes: '100037',
    config: [
      {
        type: loraTool.ZHUTI.code,
        num: 8,
      },
      {
        type: loraTool.HUAFENG.code,
        num: 8,
      },
      {
        type: loraTool.JUESHE.code,
        num: 4,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 0,
      },
      {
        type: loraTool.RENWU.code,
        num: 0,
      },
    ],
  },
  {
    tip: '3D立体',
    codes: '100038',
    config: [
      {
        type: loraTool.HUAFENG.code,
        num: 8,
      },
      {
        type: loraTool.ZHUTI.code,
        num: 4,
      },
      {
        type: loraTool.JUESHE.code,
        num: 4,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 0,
      },
      {
        type: loraTool.RENWU.code,
        num: 0,
      },
    ],
  },
  {
    tip: '电商视觉',
    codes: '100032',
    config: [
      {
        type: loraTool.ZHUTI.code,
        num: 8,
      },
      {
        type: loraTool.HUAFENG.code,
        num: 16,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 0,
      },
      {
        type: loraTool.JUESHE.code,
        num: 0,
      },
      {
        type: loraTool.RENWU.code,
        num: 0,
      },
    ],
  },
  {
    tip: '建筑空间',
    codes: '100033',
    config: [
      {
        type: loraTool.HUAFENG.code,
        num: 8,
      },
      {
        type: loraTool.ZHUTI.code,
        num: 8,
      },
      {
        type: loraTool.HUAMIAN.code,
        num: 0,
      },
      {
        type: loraTool.JUESHE.code,
        num: 0,
      },
      {
        type: loraTool.RENWU.code,
        num: 0,
      },
    ],
  },
];
